import { themeQuartz } from "ag-grid-community";

export const themeGrid = themeQuartz.withParams({
  advancedFilterBuilderButtonBarBorder: "#641585",
  /* Changes the color of the header text */
  headerTextColor: "#641585",
  /* Changes the color of the grid text */
  foregroundColor: "#212121",
  /* Changes the color of the grid background */
  backgroundColor: "#ffff",
  /* Changes the header color of the top row */
  headerBackgroundColor: "#FAFAFA",
  /* Changes the hover color of the row*/
  rowHoverColor: "rgba(0, 0, 0, 0.04)",
  focusShadow: "0px 0px 0px 3px color-mix(in srgb, transparent, #641585 50%)",
});

export const themeGridWidgets = themeQuartz.withParams({
  advancedFilterBuilderButtonBarBorder: "#641585",
  /* Changes the color of the header text */
  headerTextColor: "#641585",
  /* Changes the color of the grid text */
  foregroundColor: "#616161",
  /* Changes the color of the grid background */
  backgroundColor: "#ffff",
  /* Changes the header color of the top row */
  headerBackgroundColor: "#ffff",
  /* Changes the hover color of the row*/
  rowHoverColor: "rgba(0, 0, 0, 0.04)",
  focusShadow: "0px 0px 0px 3px color-mix(in srgb, transparent, #641585 50%)",
});
